import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import useIfFirstRender from "../../../../hooks/useIsFirstRender/useIfFirstRender";
import {useAppSelector} from "../../../../app/store";
import {selectCurrentUser} from "../../../../features/authentication/authenticationSliceSelectors";
import DetailsGridLayout from "../../../../components/uiLayouts/DetailsGridLayout/DetailsGridLayout";
import GridLayout from "../../../../components/uiLayouts/GridLayout/GridLayout";
import {getUserRole} from "../../../../helpers/user";
import {LayoutConfigEntity} from "../../../../app/enums/LayoutConfigEntity";
import QuoteForm from "../form/QuoteForm";
import QuoteGridContent from "./components/QuoteGridContent/QuoteGridContent";
import QuoteActionRow from "./components/QuoteActionRow/QuoteActionRow";
import defaultQuoteHeaderConfig from "./data/header";
import getQuoteInitialGridConfig from "./data/columns";
import QuoteFilterPanel from "./components/QuoteFilterPanel/QuoteFilterPanel";
import useMediaQuery from "../../../../hooks/useMediaQuery/useMediaQuery";
import {isMobile} from "react-device-detect";

const QuoteGrid: React.FC = () => {
    const [isSideDetailsOpened, setIsSideDetailsOpened] = useState<boolean>(false);
    const [isFullDetailsOpened, setIsFullDetailsOpened] = useState<boolean>(false);
    const [isUrlChecked, setIsUrlChecked] = useState<boolean>(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [detailsSelectedItem, setDetailsSelectedItem] = useState<string | null>(null);

    const isFirstRender = useIfFirstRender();
    const user = useAppSelector(selectCurrentUser);
    const isMaxWidth600 = useMediaQuery('(max-width:600px)');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('id')) {
            setIsFullDetailsOpened(true);
            setDetailsSelectedItem(urlParams.get('id'));
        }

        setIsUrlChecked(true);

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isFirstRender || !isUrlChecked) {
            return;
        }
        const urlParams = new URLSearchParams(window.location.search);

        if (isFullDetailsOpened && !urlParams.get('id')) {
            setIsFullDetailsOpened(false);
        }

        if (!isFullDetailsOpened && urlParams.get('id')) {
            setIsFullDetailsOpened(true);
            setDetailsSelectedItem(urlParams.get('id'));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFirstRender, searchParams, isUrlChecked]);

    if (!user || !isUrlChecked) {
        return null;
    }

    return (
        <DetailsGridLayout id={'quote-details'}
                           details={<QuoteForm id={detailsSelectedItem}
                                               isFullPageDetails={isFullDetailsOpened}
                                               close={() => {
                                                   if (searchParams.has('id')) {
                                                       searchParams.delete('id');

                                                       setSearchParams(searchParams);
                                                   }

                                                   if (isFullDetailsOpened) {
                                                       setIsFullDetailsOpened(false);
                                                   }

                                                   if (isSideDetailsOpened) {
                                                       setIsSideDetailsOpened(false);
                                                   }
                                               }}/>}
                           grid={
                               <GridLayout grid={<QuoteGridContent
                                   onRowDoubleClick={(ev) => {
                                       if (ev.dataItem) {
                                           setIsSideDetailsOpened(false);

                                           setDetailsSelectedItem(ev.dataItem.id);

                                           setSearchParams({
                                               'id': ev.dataItem.id,
                                           });

                                           setIsFullDetailsOpened(prev => !prev);
                                       }
                                   }}
                                   onRowClick={(ev) => {
                                       if (ev.dataItem) {
                                           if (isMobile || isMaxWidth600) {
                                               setDetailsSelectedItem(ev.dataItem.id);

                                               setSearchParams({
                                                   'id': ev.dataItem.id,
                                               });

                                               setIsFullDetailsOpened(prev => !prev);
                                           } else {
                                               setIsSideDetailsOpened(prev => {
                                                   setDetailsSelectedItem(ev.dataItem.id);

                                                   if (prev) {
                                                       return !(detailsSelectedItem !== null && detailsSelectedItem === ev.dataItem.id);
                                                   }

                                                   return true;
                                               });
                                           }
                                       }
                                   }}/>}
                                           header={<QuoteActionRow/>}
                                           filterPanel={<QuoteFilterPanel/>}

                                           defaultHeaderConfig={defaultQuoteHeaderConfig}
                                           defaultGridConfig={getQuoteInitialGridConfig(getUserRole(user))}

                                           entity={LayoutConfigEntity.Quote}/>
                           }
                           isFullDetailsOpened={isFullDetailsOpened}
                           setIsFullDetailsOpened={setIsFullDetailsOpened}
                           isSideDetailsOpened={isSideDetailsOpened}
                           setIsSideDetailsOpened={setIsSideDetailsOpened}/>
    );
};

export default QuoteGrid;